/**
* 基础菜单 商品管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>集团列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.varName" placeholder="输入品牌名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%;">

      <el-table-column prop="groupId" label="id">
      </el-table-column>
      <el-table-column prop="groupName" label="品牌名称" width="200">
      </el-table-column>

      <el-table-column prop="bankNote" label="打款备注">
      </el-table-column>
      <el-table-column prop="total" label="已上线商家数量" width="120">
        <template slot-scope="scope">
          <el-link type="danger" @click="xgkh(scope.row.groupId,4,1)">{{scope.row.total}}</el-link>

        </template>
      </el-table-column>
      <el-table-column prop="noTotal" label="未上线商家数量" width="120">
        <template slot-scope="scope">
          <el-link type="danger" @click="xgkh(scope.row.groupId,4,3)">{{scope.row.noTotal}}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="curAmount" label="剩余金额">
      </el-table-column>
      <el-table-column prop="czAmount" label="储值金额">
      </el-table-column>
      <el-table-column prop="useAmount" label="获得金额">
      </el-table-column>
      <el-table-column prop="code" label="成员" width="160">
        <template slot-scope="scope">
          <el-link type="danger" @click="handleEdit99(scope.$index, scope.row.groupId)">查看</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="bankInfo" label=" 银行信息" width="400">
      </el-table-column>
      <el-table-column prop="ver" label=" 版本号">
      </el-table-column>
      <el-table-column align="center" label="操作" width="400">
        <template slot-scope="scope">
          <!-- <el-button size="mini" @click="xgkh(scope.row.groupId,4,null)">查看品牌商家</el-button> -->
          <el-button size="mini" @click="xgkh(scope.row.groupId,3)">修改品牌信息</el-button>
          <el-button size="mini" v-if="scope.row.groupId!=300 " @click="xgkh(scope.row.groupId,2)">修改银行卡</el-button>
          <el-button size="mini" v-if="scope.row.groupId!=300 " @click="xgkh(scope.row.groupId,1)">修改折扣</el-button>
          <!-- <el-button size="mini" @click="xgkh(scope.row.groupId,5)">品牌管理员二维码</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" ref="editForm">
        <el-form-item label="品牌名称" prop="name">
          <el-input size="small" v-model="editForm.name" auto-complete="off" placeholder="请输入品牌名称"></el-input>
        </el-form-item>
        <el-form-item label="打款备注" prop="addr">
          <el-input size="small" v-model="editForm.bankNote" auto-complete="off" placeholder="请输入打款备注"></el-input>
        </el-form-item>
        <el-form-item label="品牌联系人" prop="linker">
          <el-input size="small" v-model="editForm.linker" auto-complete="off" placeholder="请输入品牌联系人"></el-input>
        </el-form-item>
        <el-form-item label="品牌电话" prop="tel">
          <el-input size="small" v-model="editForm.tel" auto-complete="off" placeholder="请输入品牌电话"></el-input>
        </el-form-item>
        <el-form-item label="储值金额" prop="cz_amount">
          <el-input size="small" v-model="editForm.cz_amount" auto-complete="off" placeholder="请输入储值金额"></el-input>
        </el-form-item>
        <el-form-item label="获得金额" prop="use_amount">
          <el-input size="small" v-model="editForm.use_amount" auto-complete="off" placeholder="请输入获得金额"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getMchGroupListPage,
    addMerchantGroup
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '添加',
        editForm: {
          name: '',
          cz_amount: '',
          use_amount: '',
          linker: '',
          tel: '',
          addr: ''
        },
        formInline: {
          page: 1,
          limit: 20,
          varLable: '',
          varName: '',
        },
        // 删除部门
        seletedata: {
          ids: '',
          token: localStorage.getItem('logintoken')
        },
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 20,
          total: 20
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        let pro = {
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,
          "page": parameter.page,
          "pageSize": parameter.limit,
          "name": parameter.varName,
        }
        getMchGroupListPage(pro)
          .then(res => {
            this.loading = false
            if (res.code == 0) {
              this.listData = res.data.list
              // 分页赋值
              this.pageparm.currentPage = res.data.pageNum
              this.pageparm.pageSize = res.data.pageSize
              this.pageparm.total = res.data.total

            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.getdata(this.formInline)
      },
      handleEdit99: function(index, row) {
        this.$router.push({
          name: 'groupuser',
          query: {
            id: row
          }
        })
      },
      xgkh(id, type, state) {
        console.log(id, type)
        if (type == 1) {

          const {
            href
          } = this.$router.resolve({
            path: '/group/groupdiscount',
            query: {
              id: id,

            }
          })
          window.open(href, '_blank')
        } else if (type == 2) {


          const {
            href
          } = this.$router.resolve({
            path: '/group/groupBankCard',
            query: {
              id: id,

            }
          })
          window.open(href, '_blank')


        } else if (type == 4) {
          const {
            href
          } = this.$router.resolve({
            path: '/group/clerkMerchants',
            query: {
              id: id,
              state: state
            }
          })
          window.open(href, '_blank')
          // this.$router.push({
          //   name: '品牌商家列表',
          //   query: {
          //     id: id,
          //     state:state
          //   }
          // })
        } else {

          const {
            href
          } = this.$router.resolve({
            path: '/group/groupModify',
            query: {
              id: id,

            }
          })
          window.open(href, '_blank')

        }
      },
      //显示编辑界面
      handleEdit: function(index, row) {
        this.editFormVisible = true
        if (row != undefined && row != 'undefined') {
          this.title = '修改'

        } else {
          this.title = '添加'

        }
      },
      // 编辑、增加页面保存方法
      submitForm(editData) {
        this.loading = true
        let pro = this.editForm
        addMerchantGroup(pro)
          .then(res => {
            this.loading = false
            if (res.code == 1) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.getdata(this.formInline)
              this.$message({
                type: 'success',
                message: '品牌添加成功！'
              })
              this.closeDialog()
            }
          })
          .catch(err => {
            this.loading = false
            // this.$message.error('菜单加载失败，请稍后再试！')
          })
      },

      // 关闭编辑、增加弹出框
      closeDialog() {
        this.editFormVisible = false
      }
    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/group/clerk.vue